import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast, Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import { errMsg } from "@/lib/errors";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        origin_url: window.location.origin,
      });
      setSent(true);
      toast.success("If an account exists for that email, a reset link has been sent.");
    } catch (err) {
      toast.error(errMsg(err, "Could not send reset link"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Toaster position="top-center" />
      <div className="max-w-md mx-auto px-4 py-14">
        <h1 className="font-display text-3xl font-bold text-slate-900">Reset your password</h1>
        <p className="text-slate-600 mt-2">
          Enter the email you use for FixNear and we'll send a secure link to choose a new password. The link is valid for 60 minutes.
        </p>

        {sent ? (
          <div data-testid="forgot-sent-panel" className="mt-6 card space-y-3">
            <div className="font-semibold text-slate-900">Check your inbox</div>
            <div className="text-sm text-slate-600">
              If <b>{email}</b> is a FixNear account, a password-reset link is on its way. Follow it to set a new password and sign back into the same account.
            </div>
            <div className="text-sm">
              <Link to="/login" className="text-emerald-600 font-semibold">Back to login</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 card space-y-4">
            <div>
              <label className="label">Registered email</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="field"
                autoComplete="email"
              />
            </div>
            <button
              data-testid="forgot-submit-btn"
              disabled={busy}
              className="btn-accent w-full"
            >
              {busy ? "Sending link…" : "Email me a reset link"}
            </button>
            <div className="text-sm text-slate-600 text-center">
              Remembered your password?{" "}
              <Link to="/login" className="text-emerald-600 font-semibold">Log in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
